import ResourceCard from "./resource-card"

const Video = (content) => {
  const resource = content.content

  const data = {
    title: resource.title,
    description: resource.description ? resource.description.childMarkdownRemark.excerpt : null,
    type: "videos",
    url: `/video/${resource.slug}`,
    urlType: null,
    featured: resource.featured ? resource.featured : null,
  }

  return <ResourceCard content={data} />
}

export default Video
